import '@module/PriceWatcher/pricewatcher.scss';
import { EventDispatcher, classList, gebi, hideElement, isMobileView, isShowresultPage, isValidEmail, l, lLink, lc, logEvent, lreplace, qs, qsa, roundToNearest, serializeArray, showElement, slideDown, slideUp, urlParameterDelete, urlParameterSet } from '@utils/toolbox';
import { dateAddWeeks, dateFormat, dateFormatYMD, dateIsAfter, dateIsBefore, dateIsSameDay, dateParseISO } from '@utils/dateFns';
import { eventCategories, events } from '@js/utils/event';
import { Calendar } from '@js/components/calendar';
import { CalendarRenderer } from '@js/components/calendarRenderer';
import { ConnectApi } from '@js/plugins/connectApi';
import { Modal } from '@js/components/modal';
import noUiSlider from '@js/plugins/nouislider';
import { priceWatcherGenerateTable } from '@module/PriceWatcher/PriceWatcherTable';
import { reactive, watch as vueWatch } from 'vue';
import { scrollCalendars } from '@module/SearchBox/SearchBox';
import { toaster } from '@js/components/toast';
import { useSearchFieldMulti } from '@/src/vue/components/SearchFieldMulti/SearchFieldMulti';


const { currency } = js_params;
const roundToStep = currency === 'EUR' ? 10 : 100;
const roundToMin = currency === 'EUR' ? 10 : 100;
const roundToMax = currency === 'EUR' ? 5000 : 50000;


const _defaults = {
	default: true,
	dates: {
		today: js_params.isoDates.today,
		from: js_params.isoDates.fromIndex,
		to: js_params.isoDates.toIndex
	},
	passengerTypeTranslations: {
		adult: { singular: l('searchBox.passengers.adult'), plural: l('searchBox.passengers.adults') },
		child: { singular: l('searchBox.passengers.child'), plural: l('searchBox.passengers.children') }
	},
	startingPrice: 1000
};

export const PriceWatcher = {

	priceWatcher: {
		requestTokenForm: null,
		searchBox: null
	},

	html: gebi('pricewatcher'),

	email: '',
	token: js_params.token,
	inEditMode: false,
	sortedColumn: false,
	cheapestRequestId: 0,
	_isShowresultPage: isShowresultPage(),
	searchFieldMultiVariation: 'priceWatcher',

	dates: {},

	// modal: qs('#pricewatcher-modal'),
	modal: null,
	form: qs('#pricewatcher-form'),
	results: qs('#pricewatcher-results'),
	slider: qs('#pricewatcher-day-range-slider'),
	priceSlider: qs('#slider-price'),
	calendarRenderElem: gebi('abSearchbox__dates'),
	departField: qs('.abSearchBox__depart'),
	returnField: qs('.abSearchBox__return'),
	intro: qs('#pricewatcher-intro'),
	clearDatesBtn: qs('#clear-dates-button'),
	passengers: qs('.abSearchBox__passengers'),
	passengersApplyBtn: qs('.abPassengers__applyBtn'),
	passengerCount: { adult: 1, child: 0, infant: 0 },
	priceInput: qs('#pricewatcher-price-range-max'),

	init () {
		if (!this.form) {
			return;
		}

		if (this.email) {
			this.pricewatcher.requestTokenForm = this.requestTokenForm();
		}

		this.dates.min = new Date(js_params.timestamp);
		this.dates.max = new Date(this.dates.min.getTime() + 2 * 365 * 24 * 60 * 60 * 1000);

		const today = new Date();
		const defaultDepartDate = dateFormatYMD(dateAddWeeks(today, 1));
		const defaultReturnDate = dateFormatYMD(dateAddWeeks(today, 2));

		if (!isShowresultPage()) {
			this.departField.dataset.date = defaultDepartDate;
			this.returnField.dataset.date = defaultReturnDate;
		} else {
			if (!this.token) {
				qs('.pricewatcher-page-link').style.display = 'none';
			}
		}

		this.priceWatcher.searchBox = {
			calendarRender: this.calendarRenderElem,
			datePickers: null,
			html: this.form
		};

		this.priceInput.value = _defaults.startingPrice;

		this.buildSearchForm();
		this.getTrips();
		this.addEvents();

		if (this.token) {
			urlParameterSet('token', this.token);
		} else {
			urlParameterDelete('token');
		}

		window.priceWatcher = this;

		if (isShowresultPage()) {
			this.populateForm({
				iata_from: js_params.from.iata,
				city_from: js_params.from.city,
				iata_to: js_params.to.iata,
				city_to: js_params.to.city,
				price: js_params.price,
				adults: js_params.adults,
				children: js_params.childrenAges.filter(age => age > 0).length,
				infants: js_params.childrenAges.filter(age => age == 0).length,
				date_from: js_params.leavedate,
				date_to: js_params.homedate
			});

			this.priceWatcher.showresultInitialised = true;
		}

		return this;
	},

	summonModal (restoreMode = false) {
		if (!restoreMode) {
			this.modal = new Modal({
				id: 'pricewatcher-modal',
				className: 'pricewatcher-modal',
				hideFooter: false,
				hideHeader: false,
				hideOnSwipe: false,
				resetScroll: true,
				header: l('pricewatcher.how_to'),
				footer: `<button data-action="cancelShare" class="js-close-modal abBtn--whiteBlue abBtn abBtn--flex">${l('global.simplePhrases.close')}</button>`,
				body: `
<div class="pricewatcher-modal__content-column">
	<ol class="pricewatcher-modal__list">
		<li>${l('pricewatcher.info.configure_searchfields')}</li>
		<li>${l('pricewatcher.info.press_the_button')}</li>
		<li>${l('pricewatcher.info.you_will_be_informed')}</li>
		<li>${lreplace('pricewatcher.info.pricewatches_bound_to_browser', { domain: window.location.hostname })}</li>
		<li>${l('pricewatcher.info.dont_forget')}</li>
		<li>${l('pricewatcher.info.limitations')}</li>
		<li>${l('pricewatcher.info.you_can_cancel')}</li>
	</ol>
</div>
<div class="pricewatcher-modal__content-column">
	<form id="pricewatcher-modal-form" onsubmit="event.preventDefault();">
		<div class="pricewatcher-modal__sub">
			<p class="consent-block">${l('pricewatcher.submit_email_to_register')}</p>
			<div class="input-field-section input-block">
				<div class="input-block-text">
					<input id="pricewatcher-modal-email" type="email" name="pricewatcher-modal-email" class="input-block-text" placeholder="${l('Fill_in_email', 'Fyll i din e-postadress')}">
				</div>
				<div class="input-block-section" data-action-resend-email>
					<input id="pricewatcher-register-btn" type="submit" value="${l('pricewatcher.submit')}" class="input-block-btn">
				</div>
			</div>
		</div>
	</form>
</div>`
			});
		} else {
			this.modal = new Modal({
				id: 'pricewatcher-modal',
				className: 'pricewatcher-modal',
				hideFooter: false,
				hideHeader: false,
				hideOnSwipe: false,
				resetScroll: true,
				header: l('pricewatcher.submit_email_to_recover'),
				footer: `<button data-action="cancelShare" class="js-close-modal abBtn--whiteBlue abBtn abBtn--flex">${l('global.simplePhrases.close')}</button>`,
				body: `
<div class="pricewatcher-modal__content-column">
	<form id="pricewatcher-modal-form" onsubmit="event.preventDefault();">
		<div class="pricewatcher-modal__sub">
			<div class="input-field-section input-block">
				<div class="input-block-text">
					<input id="pricewatcher-modal-email" type="email" name="pricewatcher-modal-email" class="input-block-text" placeholder="${l('Fill_in_email', 'Fyll i din e-postadress')}">
				</div>
				<div class="input-block-section">
					<input id="pricewatcher-recover-btn" type="submit" value="${l('pricewatcher.submit')}" class="input-block-btn">
				</div>
			</div>
		</div>
	</form>
</div>`
			});
		}

		this.modal.open();
	},

	compareStrings (a, b) {
		a = a.toLowerCase();
		b = b.toLowerCase();

		return (a < b) ? -1 : (a > b) ? 1 : 0;
	},

	isUserRegistered () {
		return (this.token || this.email) ? true : false;
	},

	showLoader () {
		qs('#m-loader').classList.add('m-loader--visible');
	},

	hideLoader () {
		setTimeout(function () {
			qs('#m-loader').classList.remove('m-loader--visible');
		}, 300);
	},

	setEmail (inputEmail) {
		gebi('pricewatcher-email').value = inputEmail;
		this.email = inputEmail;
	},

	getUserEmailByToken () {
		return ConnectApi('PriceWatcher', 'getUserEmailByToken', [this.token]);
	},

	getFormData () {
		const formArr = serializeArray(this.form).filter(field => !['from', 'to'].includes(field.name)); // unsused input field present with SearchFieldMulti

		const formObj = {};

		formArr.forEach(obj => formObj[obj.name] = obj.value);

		formObj.iata_from = this.searchFieldMultiData.legs[0].fromIatas.length > 0 ? this.searchFieldMultiData.legs[0].fromIatas[0].iata : '';
		formObj.iata_to = this.searchFieldMultiData.legs[0].toIatas.length > 0 ? this.searchFieldMultiData.legs[0].toIatas[0].iata : '';


		if (qs('.abSearchBox__depart .abSearchBox__value').innerHTML) {
			formObj.date_from = qs('.abSearchBox__depart').dataset.date;
			formObj.date_to = qs('.abSearchBox__return').dataset.date;
		} else {
			formObj.date_from = '';
			formObj.date_to = '';
		}

		formObj.adults = this.passengerCount.adult;
		formObj.children = this.passengerCount.child;
		formObj.infants = this.passengerCount.infant;

		formObj.price = this.priceSlider.noUiSlider.get();

		formObj.direct_flight_only = qs('input#pricewatcher-checkbox-direct').checked ? '1' : '0';
		formObj.weekend_only = qs('input#pricewatcher-checkbox-weekend').checked ? '1' : '0';

		formObj.from_showresult = this._isShowresultPage;

		// this.token also covers users that just registered
		if (this.token) {
			formObj.token = this.token;
		} else if (formObj.token === 'undefined') {
			delete formObj.token;
		}

		return [formObj];
	},

	validateForm () {
		const departIsEmpty = this.searchFieldMultiData.legs[0].fromIatas.length === 0;
		const returnIsEmpty = this.searchFieldMultiData.legs[0].toIatas.length === 0;

		const selectedMaxPrice = parseInt(this.priceSlider.noUiSlider.get());

		if (departIsEmpty || returnIsEmpty || selectedMaxPrice === 0) {
			return false;
		} else {
			return true;
		}
	},

	populateForm (trip) {
		if (trip === undefined) {
			this.form.classList.remove('pricewatcher-form--edit');
			this.searchFieldMultiData.legs[0].fromIatas = [];
			this.searchFieldMultiData.legs[0].toIatas = [];
			this.resetPassengersField();
			qs('input#pricewatcher-checkbox-direct').checked = false;
			qs('input#pricewatcher-checkbox-weekend').checked = false;
			qs('.abSearchBox__depart').dataset.date = '';
			qs('.abSearchBox__return').dataset.date = '';
		} else {
			this.form.classList.add('pricewatcher-form--edit');

			// Set searchfields to respective value to edit
			this.searchFieldMultiData.legs[0].fromIatas = [{ iata: trip.iata_from, text: trip.city_from, isMetro: trip.city_from_isMetro }];
			this.searchFieldMultiData.legs[0].toIatas = [{ iata: trip.iata_to, text: trip.city_to, isMetro: trip.city_to_isMetro }];

			if (isShowresultPage() && window?.resultsRender?.response?.meta?.sortingTop?.best?.lowestprice) {
				trip.price = window.resultsRender.response.meta.sortingTop.best.lowestprice - roundToStep;
			}

			_defaults.startingPrice = trip.price;

			// Set the min/max values of the price slider
			this.priceSlider.noUiSlider.updateOptions({
				start: [roundToNearest(trip.price, roundToStep)],
				range: {
					min: roundToMin,
					max: roundToNearest(trip.price * 1.1, roundToStep)
				}
			}, true);


			const adultsSelectOption = qs('select#pricewatcher-adults option[value="' + trip.adults + '"]', this.form);
			if (adultsSelectOption) {
				adultsSelectOption.selected = true;
			}
			const childrenSelectOption = qs('select#pricewatcher-children option[value="' + trip.children + '"]', this.form);
			if (childrenSelectOption) {
				childrenSelectOption.selected = true;
			}
			qs('input#pricewatcher-checkbox-direct').checked = (trip.direct_flight_only) ? true : false;
			qs('input#pricewatcher-checkbox-weekend').checked = (trip.weekend_only) ? true : false;

			// Set date input fields to respective value to edit
			this.initDateField('from', trip.date_from);
			this.initDateField('to', trip.date_to);

			if (!this._isShowresultPage) {
				this.slider.noUiSlider.set([trip.date_diff_min, trip.date_diff_max]);
			}

			this.passengerCount.adult = trip.adults;
			this.passengerCount.child = trip.children;
			this.passengerCount.infant = trip.infants;

			if (!this._isShowresultPage) {
				this.passengersApplyChanges();
			}
		}
		qs('input#pricewatcher-trip-id').value = this.inEditMode;
		this.hideStatus();
	},

	hideStatus () {
		slideUp(qs('#pricewatcher-status div'));
	},

	getFormattedIata (iata, text, isMetro = false) {
		return [
			{
				iata: iata,
				text: text,
				isMetro: isMetro
			}
		];
	},

	initCalendarRenderer () {
		this.priceWatcher.searchBox.calendarRender = new CalendarRenderer({
			html: this.calendarRenderElem,
			callbacks:
			{
				onShow: () => {
					if (isMobileView()) {
						this.initialScrollPos = window.scrollY;
						if (this.showresultMode) {
							this.setFixedStyles();
						}
					}
				},
				onHide: () => {
					if (isMobileView()) {
						window.scrollTo({ top: this.initialScrollPos, behavior: 'smooth' });
					}
					if (this.priceWatcher.searchBox.datePickers.tripType === 1) {
						if (this.priceWatcher.searchBox.datePickers.departSelected) {
							this.priceWatcher.searchBox.datePickers.departSelected = false;

							const departDateObject = new Date(this.priceWatcher.searchBox.datePickers.departDate);
							const returnDateObject = new Date(this.priceWatcher.searchBox.datePickers.returnDate);

							const departIsBeforeReturn = dateIsBefore(departDateObject, returnDateObject);
							const datesAreTheSame = dateIsSameDay(departDateObject, returnDateObject);

							if (departIsBeforeReturn || datesAreTheSame) {
								this.setDateField(this.priceWatcher.searchBox.datePickers.departField, this.priceWatcher.searchBox.datePickers.departDate);
								this.setDateField(this.priceWatcher.searchBox.datePickers.returnField, this.priceWatcher.searchBox.datePickers.returnDate);
							}
						}
					}

					if (this.showresultMode) {
						this.removeFixedStyles();
					}
				},
				onReset: () => {
					this.priceWatcher.searchBox.datePickers.resetDates();
				},
				onSlide: (direction) => {
					scrollCalendars(direction);
				}
			}
		});
	},

	initCalendar () {
		this.priceWatcher.searchBox.datePickers = new Calendar({
			searchBox: this.priceWatcher.searchBox,
			callbacks:
			{
				onDepartDatePicked: (instance) => {
					const { departField, departDate, returnField, returnDate } = instance;

					const departDateObject = new Date(departDate);
					const returnDateObject = new Date(returnDate);
					const departIsAfterReturn = dateIsAfter(departDateObject, returnDateObject);
					const datesAreTheSame = dateIsSameDay(departDateObject, returnDateObject);

					// Check for returnField since isAfter will return true when returnDateObject is null
					if (returnField && (departIsAfterReturn || datesAreTheSame)) {
						this.setDateField(returnField, departDate);
					}

					this.setDateField(departField, departDate);

					if (instance.tripType !== 1) {
						setTimeout(() => this.calendarRender.hide(), 400);
					}
				},
				onReturnDatePicked: (instance) => {
					const { departField, departDate, returnField, returnDate } = instance;
					const departDateObject = new Date(departDate);
					const returnDateObject = new Date(returnDate);
					const departIsBeforeReturn = dateIsBefore(departDateObject, returnDateObject);
					const datesAreTheSame = dateIsSameDay(departDateObject, returnDateObject);

					if (departIsBeforeReturn || datesAreTheSame) {
						this.setDateField(departField, departDate);
					}

					this.setDateField(returnField, returnDate);

					if (instance.tripType === 1) {
						setTimeout(() => this.priceWatcher.searchBox.calendarRender.hide(), 400);
					}
				},
				onScroll: () => {
					scrollCalendars();
				}
			}
		});
	},

	buildSearchForm () {
		const filtersTop = document.getElementById('pricewatcher-form');
		const inputs = qsa('.SearchFieldMulti', filtersTop);

		this.searchFieldMultiData = reactive({
			tripType: 2,
			legs: [
				{
					fromIatas: [],
					toIatas: []
				}
			]
		});

		vueWatch(() => this.searchFieldMultiData.legs[0], () => this.getCheapest(), { deep: true });

		if (!this._isShowresultPage) {
			this.priceWatcher.fromField = useSearchFieldMulti({
				label: l('global.simplePhrases.From'),
				legIndex: 0,
				bound: 'from',
				data: this.searchFieldMultiData
			});
			this.priceWatcher.fromField.mount(inputs[0]);
			this.priceWatcher.toField = useSearchFieldMulti({
				label: l('global.simplePhrases.To'),
				legIndex: 0,
				bound: 'to',
				data: this.searchFieldMultiData
			});
			this.priceWatcher.toField.mount(inputs[1]);
		}

		noUiSlider.create(this.priceSlider, {
			start: [_defaults.startingPrice],
			step: roundToStep,
			connect: [true, false],
			range: {
				min: roundToMin,
				max: roundToMax
			}
		});

		if (!this._isShowresultPage) {
			noUiSlider.create(this.slider, {
				start: [4, 15],
				connect: [false, true, false],
				range: {
					min: [1],
					max: [30]
				}
			});

			this.slider.classList.add('noUi-themed');

			gebi('pricewatcher-day-range-min').innerText = 4;
			gebi('pricewatcher-day-range-max').innerText = 15;
			this.priceInput.value = 500;

			this.initCalendarRenderer();
			this.initCalendar();
		}

		this.form.querySelector('input#pricewatcher-token').value = this.token;
		this.form.querySelector('input#pricewatcher-trip-id').value = this.inEditMode;

		if (this._isShowresultPage) {
			hideElement(this.intro);
			hideElement('#pricewatcher-status');

			if (!this.isUserRegistered()) {
				hideElement(this.form.querySelector('a.pricewatcher-form__more'));
			}
		}
	},

	refreshCalendar () {
		const params = {
			elems: {
				departField: this.departField,
				returnField: this.returnField
			},
			dates: {
				departDate: this.departField.dataset.date,
				returnDate: this.returnField.dataset.date
			},
			tripType: 1
		};

		this.priceWatcher.searchBox.calendarRender.show();
		this.priceWatcher.searchBox.datePickers.render(params);
	},

	setDateField (field, strDate) {
		if (strDate) {
			const date = dateParseISO(strDate);
			const monthDay = dateFormat(date, 'MMM d');
			const dayName = dateFormat(date, 'EEE');
			const value = `${monthDay}, <small>${dayName}</small>`;

			field.dataset.date = dateFormatYMD(date);
			field.getElementsByClassName('abSearchBox__value')[0].innerHTML = value;

			this.clearDatesBtn.classList.remove('disabled');

			return this;
		}
	},

	showMoreOptions () {
		this.form.classList.add('pricewatcher-form--expanded');
		slideDown(this.form.querySelector('.pricewatcher-form__section--hidden'));
	},

	hideMoreOptions () {
		this.form.classList.remove('pricewatcher-form--expanded');
		slideUp(this.form.querySelector('.pricewatcher-form__section--hidden'));
	},

	numbersOnly (numbers) {
		return numbers.replace(/[^0-9]+/g, '');
	},

	initDateField (fieldDirection, date) {
		let field = null;
		if (fieldDirection === 'from') {
			field = qs('.abSearchBox__depart');
		} else {
			field = qs('.abSearchBox__return');
		}

		const fieldDate = (new Date(date) < new Date()) ? null : date;

		this.setDateField(field, fieldDate);
	},

	calendarRenderClosed () {
		if (this.priceWatcher.searchBox.datePickers.departSelected) {
			this.priceWatcher.searchBox.datePickers.departSelected = false;

			const departDate = new Date(this.priceWatcher.searchBox.datePickers.departDate);
			const returnDate = new Date(this.priceWatcher.searchBox.datePickers.returnDate);

			const returnIsBeforeDepart = dateIsBefore(returnDate, departDate);

			if (!returnIsBeforeDepart) {
				this.setDateField(this.priceWatcher.searchBox.datePickers.departField, departDate);
				this.setDateField(this.priceWatcher.searchBox.datePickers.returnField, returnDate);
			}
		}
	},

	resetCalendars () {
		this.priceWatcher.searchBox.datePickers.resetDates();
		qs('.abSearchBox__depart .abSearchBox__value').innerHTML = '';
		qs('.abSearchBox__depart').dataset.date = '';
		qs('.abSearchBox__return .abSearchBox__value').innerHTML = '';
		qs('.abSearchBox__return').dataset.date = '';
		this.clearDatesBtn.classList.add('disabled');
	},

	save () {
		if (!this.isUserRegistered()) {
			this.summonModal(false);
		} else {
			if (this.validateForm()) {
				this.watch();
			} else {
				this.displayMsg(l('pricewatcher.error_missing_fields'), 2000, true);
			}
		}
	},

	open (ev) {
		// window.scrollTo({ top: 0 });
		classList('#priceGuideWrapper').add('open');
	},

	close () {
		classList('#priceGuideWrapper').remove('open');
	},

	addEvents () {
		const _this = this;
		document.body.addEventListener('click', (event) => {
			const target = event.target;

			if (target.closest('[data-action=open-pricewatcher-modal]')) {
				event.preventDefault();
				this.summonModal(false);
				return;
			}

			if (target.closest('[data-action=open-pricewatcher-login-modal]')) {
				event.preventDefault();
				this.summonModal(true);
				return;
			}

			// Save for registered
			if (target.closest('.pricewatcher-form__save-btn')) {
				event.preventDefault();
				this.save();

				logEvent(events.setPriceAlert, eventCategories.feature);

				return;
			}

			if (target.closest('.acceptPriceWatch')) {
				if (this.validateForm()) {
					this.watch();
				} else {
					this.displayMsg(l('pricewatcher.error_missing_fields'), 2000, true);
				}
				return;
			}

			if (target.closest('#pricewatcher-register-btn')) {
				this.registerUser();
				return;
			}

			if (target.closest('#pricewatcher-register')) {
				this.registerUser();
				return;
			}

			if (target.closest('#pricewatcher-recover-btn')) {
				event.preventDefault();
				this.restoreUser();
				return;
			}

			if (!this._isShowresultPage) {
				if (target.closest('button.pricewatcher-form__more-btn')) {
					if (this.form.classList.contains('pricewatcher-form--expanded')) {
						this.hideMoreOptions();
					} else {
						this.showMoreOptions();
					}
					return;
				}

				if (target.closest('.SearchFieldMulti__checked_iatas_container')) {
					target.closest('.SearchFieldMulti__checked_iatas_container').nextElementSibling.focus();
					return;
				}

				if (target.closest('.abSearchBox__depart')) {
					this.priceWatcher.searchBox.datePickers.focus = 'depart';
					this.refreshCalendar();
					return;
				} else if (target.closest('.abSearchBox__return')) {
					this.priceWatcher.searchBox.datePickers.focus = 'return';
					this.refreshCalendar();
					return;
				}

				if (target.closest('#clear-dates-button:not(.disabled)')) {
					event.preventDefault();
					this.priceWatcher.searchBox.datePickers.focus = 'depart';
					this.resetCalendars();
					return;
				}

				if (target.closest('.pricewatcher-table__item-tools button')) {
					const id = target.closest('li').dataset.id;
					const action = target.closest('.pricewatcher-table__item-tools button').dataset.action === 'delete-pricewatcher' ? 'delete' : 'edit';
					this.form.classList.remove('pricewatcher-form--flashed');
					this.modifyTrip(id, action);
					return;
				}

				if (target.matches('.abSearchBox__passengers')) {
					event.stopPropagation();
					this.focusPassengersField(target);
					return;
				}

				// Disable or not the price alert for mobile
				if (isMobileView() && target.closest('.fakeTable--item:not(.pricewatcher-table__item-tools)')) {
					const closest = target.closest('.fakeTable--item');
					closest.parentNode.querySelector('.checkbox').click();
					return;
				}

				// PASSENGERS
				const action = target.dataset.action;

				if (action === 'apply-passengers') {
					event.stopPropagation();
					this.passengersApplyChanges();
				} else if (action === 'apply-date') {
					this.priceWatcher.searchBox.calendarRender.hide();
				} else if (action === 'add-passenger') {
					if (!target.classList.contains('abPassengers__btn--disabled')) {
						this.passengersBtnClicked(target.dataset.type, 'add');
					}

					event.preventDefault();
					return;
				} else if (action === 'remove-passenger') {
					if (!target.classList.contains('abPassengers__btn--disabled')) {
						this.passengersBtnClicked(target.dataset.type, 'remove');
					}

					event.preventDefault();
					return;
				}

				if (!target.closest('#abSearchbox__dates')) {
					this.calendarRenderClosed();
					this.priceWatcher?.searchBox?.calendarRender?.hide?.();
				}

				if (!target.closest('#pricewatcher-passengers')) {
					gebi('pricewatcher').classList.remove('abSearchBox--show-overlay');
					classList('#pricewatcher-passengers').remove('abSearchBox__row--focus-passengers');
				}
				// When the input is changed, set the slider value
				this.form.addEventListener('focus', (e) => {
					const target = e.target.matches('.pricewatcher-form__label') ? e.target : null;
					if (target) {
						target.value = '';
					}
				});

				this.form.addEventListener('keyup', (e) => {
					const target = e.target.matches('.pricewatcher-form__label') ? e.target : null;
					if (target) {
						target.value = this.numbersOnly(target.value);


						const key = e.keyCode;
						const keys = [13, 37, 48, 39, 40];

						if (!keys.includes(key) && target.value.length > 2) {
							this.getCheapest();
						}
					}
				});

				this.slider.noUiSlider.on('update', (values) => {
					const vals = values.map(value => Math.round(value));
					const dateMinInput = document.getElementById('pricewatcher-date-min');
					const dateMaxInput = document.getElementById('pricewatcher-date-max');

					dateMinInput.value = vals[0];
					dateMaxInput.value = vals[1];

					gebi('pricewatcher-day-range-min').innerText = vals[0];
					gebi('pricewatcher-day-range-max').innerText = vals[1];
				});

				qs('#pricewatcher-results').addEventListener('change', function (e) {
					const target = e.target.matches('input[type="checkbox"]') ? e.target : null;
					if (target) {
						const action = target.checked ? 'activate' : 'deactivate';
						const id = target.closest('li').dataset.id;

						target.closest('li').dataset.active === '1' ? target.closest('li').dataset.active = 0 : target.closest('li').dataset.active = 1;

						_this.modifyTrip(id, action);
					}
				});
			}
		});


		// stop enter in input fields from implicitly submitting the form
		this.form.addEventListener('keypress', function (e) {
			if (e.key === 'Enter' && e.target.matches('input')) {
				e.preventDefault();
			}
		});

		// Round values to nearest 10 if euro and 100 if SEK/NOK/DKK/ZAR

		this.priceSlider.noUiSlider.on('update', (values) => {
			this.priceInput.value = roundToNearest(values[0], roundToStep);
		});

		// Add enter key event to input fields
		this.priceInput.addEventListener('keypress', (e) => {
			if (e.keyCode === 13) {
				e.preventDefault();
				e.stopPropagation();

				this.priceSlider.noUiSlider.set([e.target.value]);

				if (isMobileView()) {
					this.priceInput.blur();
				}
			}
		});

		this.priceInput.addEventListener('blur', (event) => {
			this.priceSlider.noUiSlider.set([event.target.value]);
		});
	},

	requestTokenForm (userEmail = this.email) {
		ConnectApi('PriceWatcher', 'requestToken', [{ email: userEmail }]).then((data) => {
			const element = qs('[data-price-hunter-login]');
			if (element) {
				element.innerHTML = lreplace(data.message.key, data.message.params);
			} else {
				toaster.newToast(lreplace(data.message.key, data.message.params), 'success', 'stays');
			}
		});
	},

	registerUser () {
		const email = gebi('pricewatcher-modal-email').value;

		if (isValidEmail(email)) {
			this.setEmail(email);
			this.watch();
		} else {
			alert(l('pricewatcher.form.emailError', 'Felaktig e-postadress'));
		}
	},

	restoreUser () {
		const email = gebi('pricewatcher-modal-email').value;

		if (isValidEmail(email)) {
			this.setEmail(email);
			this.requestTokenForm();
			this?.modal?.close?.();

			EventDispatcher.dispatch('showcase:reset');
		} else {
			alert(l('pricewatcher.form.emailError', 'Felaktig e-postadress'));
		}
	},

	getCheapest () {
		if (isShowresultPage()) {
			return;
		}
		const formData = this.getFormData();
		const from = formData[0].iata_from;
		const to = formData[0].iata_to;

		// responses can arrive out of order, only the latest request may touch the ui
		const requestId = ++this.cheapestRequestId;

		if (from && to) {
			ConnectApi('PriceWatcher', 'getCheapest', formData).then((data) => {
				if (requestId !== this.cheapestRequestId) {
					return;
				}

				// keep the saved price while the form still shows the edited watch's route
				const editedTrip = this.priceWatcher.trips?.find(trip => Number(trip.id) === Number(this.inEditMode));
				const keepSavedPrice = editedTrip && editedTrip.iata_from === from && editedTrip.iata_to === to;

				if (data) {
					slideUp(gebi('pricewatcher-not-found'));
					const cheapestLink = qs('#pricewatcher-cheapest-link');
					cheapestLink.href = `/${lLink('global.navigation.resultsLink')}?id=${data.id}`;
					cheapestLink.innerHTML = lc(data.price);

					// Change to cheapest only if user hasn't touched it
					if (!isShowresultPage()) {
						data.price = data.price - roundToStep;
						const start = keepSavedPrice ? Number(this.priceSlider.noUiSlider.get()) : roundToNearest(data.price, roundToStep);
						this.priceSlider.noUiSlider.updateOptions({
							start: [start],
							range: {
								min: roundToMin,
								max: Math.max(roundToNearest(data.price * 3, roundToStep), start)
							}
						}, true);
					}
					slideDown(gebi('pricewatcher-cheapest'));
				} else {
					if (!keepSavedPrice) {
						this.priceSlider.noUiSlider.updateOptions({
							start: [_defaults.startingPrice],
							range: {
								min: roundToMin,
								max: roundToMax
							}
						}, true);
					}

					slideUp(gebi('pricewatcher-cheapest'));
					slideDown(gebi('pricewatcher-not-found'));
				}
			});
		}
	},

	getTrips () {
		if (this._isShowresultPage) {
			return;
		}

		if (!this.isUserRegistered()) {
			this.renderTrips();
			return;
		}

		ConnectApi('PriceWatcher', 'listAll', [this.token]).then((data) => {
			try {
				this.priceWatcher.trips = data || [];

				if (!data?.length) {
					// No results
					hideElement(this.results);
					return;
				}
				this.renderTrips();
			} catch (e) {
				console.log(e, data);
			}
		});
	},

	async renderTrips () {
		const isUserRegistered = this.isUserRegistered();
		const html = priceWatcherGenerateTable(this?.priceWatcher?.trips, this.sortedColumn, this.inEditMode, isUserRegistered);

		hideElement(this.intro);
		qs('[data-price-hunter-table]').innerHTML = html;

		showElement(this.results);

		this.sortedColumn = false;
		this.inEditMode = false;

		// Add unsubscribe link
		if (isUserRegistered) {
			if (!this.email) {
				this.email = await this.getUserEmailByToken(this.token);
			}
			if (qs('.pricewatcher-remove-me')) {
				return;
			}

			this.results.insertAdjacentHTML('afterend', `<a href="/unsubscribe?email=${this.email}" class="pricewatcher-remove-me abBtn abBtn--whiteBlue">${l('unsubscribePage.message.remove_account')}</a>`);
		}
	},

	modifyTrip (id, action) {
		console.log(id, action);
		if (action === 'activate') {
			this.showLoader();
			ConnectApi('PriceWatcher', 'activate', [{ active: 1, id: id, token: this.token }]).then(() => {
				this.hideLoader();
			});
		} else if (action === 'deactivate') {
			this.showLoader();
			ConnectApi('PriceWatcher', 'activate', [{ active: 0, id: id, token: this.token }]).then(() => {
				this.hideLoader();
			});
		} else if (action === 'delete') {
			this.showLoader();
			ConnectApi('PriceWatcher', 'remove', [{ id: id, token: this.token }]).then(() => {
				this.getTrips();
				this.hideLoader();
			});
		} else if (action === 'edit') {
			this.inEditMode = id;

			for (let i = 0; i < this.priceWatcher.trips.length; i++) {
				if (Number(this.priceWatcher.trips[i].id) === Number(id)) {
					this.populateForm(this.priceWatcher.trips[i]);
				}
			}

			this.showMoreOptions();

			window.scrollTo({ top: 0, behavior: 'smooth' });

			this.form.classList.add('pricewatcher-form--flashed');
		}
	},

	fadeInOutNotification (target, visibleFor) {
		const fadingDuration = 800;
		const delay = 100;

		target.style.display = 'flex';

		let t = delay;
		setTimeout(() => target.classList.add('priceWatcher--visible'), t);

		t += fadingDuration + visibleFor;
		setTimeout(() => target.classList.remove('priceWatcher--visible'), t);

		t += fadingDuration;
		setTimeout(() => target.style.display = '', t);
	},

	displayConfirmationMsg (msg) {
		const readingSpeed = 200 / 60000; // 200 words per minute in low average
		const nbWords = msg.split(' ').length;

		const duration = Math.round(nbWords / readingSpeed);
		this.displayMsg(msg, duration);
	},

	displayMsg (msg, duration, isError = false) {
		const notification = document.querySelector('.priceWatcher__notification');
		if (isError) {
			notification.classList.add('priceWatcher--error');
		} else {
			notification.classList.remove('priceWatcher--error');
		}

		notification.querySelector('.notification__content').innerHTML = msg;
		this.fadeInOutNotification(notification, duration);
	},

	watch () {
		this?.modal?.close?.();
		this.showLoader();

		if (this.inEditMode !== false) {
			ConnectApi('PriceWatcher', 'edit', this.getFormData()).then((data) => {
				if (data.success === '1' || data.success === true) {
					this.populateForm();
					this.getTrips();
				} else {
					this.displayMsg(lreplace(data.message.key, data.message.parameters), 2000, true);
				}
				this.hideLoader();
			});
		} else {
			ConnectApi('PriceWatcher', 'watch', this.getFormData()).then((data) => {
				if (data.success === '1' || data.success === true) {
					//
					if (this._isShowresultPage) {
						let messageTranslated = lreplace(data.message.key, data.message.parameters);

						// If logged in append login link to the message
						if (data.hasOwnProperty('token') || this.token) {
							const token = data.token || this.token;
							messageTranslated += '<br><br> <a href="/' + lLink('global.navigation.priceWatcherLink') + '?token=' + token + '" class="pricewatcher-form__more abBtn abBtn--whiteBlue">' + l('pricewatcher.manage') + ' <i class="icon-chevron-right pricewatcher-form__chevron"></i></a>';
						}

						toaster.newToast(messageTranslated, 'success', 'stays');
						// slideToggle('#priceGuideWrapper');
						gebi('priceGuideWrapper').classList.toggle('open');

						this.hideLoader();
						return;
					}
					// when an account is created for the first time the token is returned so that the user don't have to login via an email link.
					if (data.hasOwnProperty('token')) {
						this.token = data.token;
						this.populateForm();
						urlParameterSet('token', this.token);
					} else {
						this.displayConfirmationMsg(lreplace(data.message.key, data.message.parameters));
					}
				} else {
					this.displayMsg(lreplace(data.message.key, data.message.parameters), 2000, true);
				}
				if (this.token) {
					this.getTrips();
				}

				this.hideLoader();
			});
		}

		if (this._isShowresultPage) {
			EventDispatcher.dispatch('pricealert:close');
		}
	},

	// Passengers should be an easy component
	passengersApplyChanges () {
		let text = this.passengerCount.adult + ' ';

		text += this.passengerCount.adult > 1 ? _defaults.passengerTypeTranslations.adult.plural : _defaults.passengerTypeTranslations.adult.singular;

		const totalChildren = this.passengerCount.child + this.passengerCount.infant;
		if (totalChildren) {
			text += ', ' + totalChildren + ' ';
			text += totalChildren > 1 ? _defaults.passengerTypeTranslations.child.plural : _defaults.passengerTypeTranslations.child.singular;
		}

		qs('[data-passenger-type="adult"] .abPassengers__count').innerHTML = this.passengerCount.adult;
		qs('[data-passenger-type="child"] .abPassengers__count').innerHTML = this.passengerCount.child;
		qs('[data-passenger-type="infant"] .abPassengers__count').innerHTML = this.passengerCount.infant;

		qs('.abSearchBox__passengers .abSearchBox__value').innerHTML = text;

		classList('[data-passenger-type="adult"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', this.passengerCount.adult === 1);
		classList('[data-passenger-type="child"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', !this.passengerCount.child);
		classList('[data-passenger-type="infant"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', !this.passengerCount.infant);

		gebi('pricewatcher-passengers').classList.remove('abSearchBox__row--focus-passengers');
		gebi('pricewatcher').classList.remove('abSearchBox--show-overlay');
		this.getCheapest();
	},

	passengersBtnClicked (type, action) {
		const input = qs(`[data-passenger-type="${type}"] .abPassengers__count`);

		if (action === 'add') {
			this.passengerCount[type] += 1;
		} else if (action === 'remove') {
			if (type !== 'adult' || this.passengerCount.adult !== 1) {
				this.passengerCount[type] -= 1;
			}
		}
		input.innerHTML = this.passengerCount[type];

		// If no adults, disable minus button
		classList('[data-passenger-type="adult"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', this.passengerCount.adult === 1);

		// If no children, disable minus button
		classList('[data-passenger-type="child"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', !this.passengerCount.child);


		// If no infants, disable minus button
		classList('[data-passenger-type="infant"] .abPassengers__btn-minus').toggle('abPassengers__btn--disabled', !this.passengerCount.infant);

		this.getCheapest();
	},

	focusPassengersField (elem = null) {
		if (!elem) {
			elem = this.html.querySelector('.abSearchBox__passengers');
		}
		this.focusField(elem, 'abSearchBox__row--focus-passengers');
	},

	resetPassengersField () {
		this.passengerCount = { adult: 1, child: 0, infant: 0 };
		this.passengersApplyChanges();
	},

	focusField (field, style) {
		const row = field.parentNode.closest('.pricewatcher-field-container__section');

		if (row.classList.contains(style)) {
			return false;
		}

		this.html.classList.add('abSearchBox--show-overlay');

		row.classList.add(style);

		if (isMobileView()) {
			if (this.showresultMode) {
				const overlay = this.html.getElementsByClassName('abSearchBox__overlay')[0];
				const searchBoxHeight = document.getElementsByClassName('abShowResultSearchBox__inner')[0].clientHeight;

				overlay.style.height = Math.max(window.innerHeight, searchBoxHeight) + 'px';
			}

			document.body.style.overflow = 'hidden';

			window?.recentSearches?.stop?.();
		}

		return true;
	}
};
